export default __webpack_public_path__ + "paddle_sports50779c.svg";